// Function for creating the data in the integrations

export function createData(integrations, logo, description, status)
{
  return { integrations, logo, description, status };
}
